module.exports = __webpack_public_path__ + "static/media/indigenet-g2s_full_grey.0724b8c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/indigenet-g2s_full_grey.png
// module id = 1058
// module chunks = 0